export default function MobileDrawer({ open, onClose, children }) {
  if (!open) return null;
  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: "fixed", inset: 0, zIndex: 199,
          background: "rgba(0,0,0,0.4)",
        }}
      />
      {/* Drawer panel */}
      <div style={{
        position: "fixed", top: 0, right: 0, bottom: 0, zIndex: 200,
        width: 260, background: "white",
        boxShadow: "-4px 0 20px rgba(0,0,0,0.15)",
        overflowY: "auto",
      }}>
        {children}
      </div>
    </>
  );
}
